let fallbackCounter = 0;

export function createIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for environments without crypto.randomUUID (e.g., some test runners).
  const now = Date.now();
  const random = Math.random().toString(36).slice(2, 10);
  fallbackCounter += 1;
  return `${now}-${random}-${fallbackCounter}`;
}
